import * as React from "react";
import "./AppContainer.scss";
import { Header, HeaderProps } from "../header/Header";
import { Footer } from "../footer/Footer";

export interface AppContainerProps {
    children: React.ReactNode;
    header: HeaderProps;
}

const AppContainer = (props: AppContainerProps) => {
    return (
        <div className="eos-main">
            <Header {...props.header} />
            <main className="eos-content">
                <div>{props.children}</div>
            </main>
            <Footer />
        </div>
    );
};

export default AppContainer;
